export const HomeAccessActions = {
  Access: '[Home Access] Change accesses to products in WM',
  Error: '[Home Access] Change error in request',
  ErrorMessage: '[Home Access] Change error message in request',
  Load: '[Home Access] Change loading screen',
};
